<template>
  <v-container
    :id="`${displayAsPlural.toLowerCase().replaceAll(' ', '-')}-view`"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          :icon="appItem.icon"
          :icon-small="true"
        >
          <template #title>
            <v-container class="py-0">
              <v-row>
                <v-col sm="8">
                  <h3>{{ displayAsSingular }} Maintenance</h3>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <v-form>
            <v-container
              class="py-0 pb-5"
            >
              <v-row
                v-if="customers.data.length > 1"
                no-gutters
              >
                <v-col
                  cols="12"
                  sm="12"
                  lg="5"
                >
                  <select-customer
                    id="2-maintain-customer"
                    v-model="customers.selectedItem"
                    :appendhint="`to select from its ${displayAsPluralCategories}`"
                  />
                </v-col>
              </v-row>

              <v-row
                align="end"
                no-gutters
              >
                <v-col
                  cols="12"
                  sm="12"
                  lg="5"
                >
                  <select-category
                    id="2-maintain"
                    v-model="categories.selectedItem"
                    :appendhint="`to view its ${displayAsPlural}`"
                  />
                </v-col>
              </v-row>

              <v-row
                no-gutters
              >
                <v-col
                  cols="12"
                  class="text-left"
                >
                  <part-table
                    ref="maintenancePartTable"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'
  import { mapGetters } from 'vuex'
  import MaterialCard from '@/components/MaterialCard'
  import SelectCategory from '@/components/keys/SelectCategory'
  import PartTable from '@/components/maintenance/tables/PartTable'

  export default {
    name: 'PartsView',

    components: {
      MaterialCard,
      SelectCategory,
      PartTable,
    },

    data () {
      return {
        appItem: null,
      }
    },

    computed: {
      ...mapGetters('app', [
        'getAppItem',
      ]),
      users: get('user/users'),
      customers: get('customer/customers'),
      categories: get('category/categories'),
      displayAsSingular: get('part/displayAsSingular'),
      displayAsPlural: get('part/displayAsPlural'),
      displayAsPluralCategories: get('category/displayAsPlural'),
    },

    created () {
      this.appItem = this.getAppItem(this.$options.name)
      this.$store.dispatch('user/setPageName', this.$options.name)
    },

    mounted () {
      if (!this.categories.selectedItem) {
        this.$store.dispatch('part/setEmpty')
      }
    },
  }
</script>
